<template>
  <div>
    <b-modal
      id="view-modal-contract"
      hide-footer
      no-close-on-backdrop
      size="lg"
      modal-class="modern-modal"
    >
      <template v-slot:modal-title>
        <div class="modal-title-modern">
          <i class="fas fa-file-contract mr-2"></i>
          Vizualizar Contrato
        </div>
      </template>

      <div class="modal-content-modern p-3">
        <p class="mb-2">
          <strong>Nome do contrato:</strong> {{ contract.name }}
        </p>

        <p class="mb-2">
          <strong>Contrato:</strong>
        </p>

        <div v-html="formatContract(replaced_text)"></div>
      </div>

      <div v-if="errors.length > 0">
        <ErrorsMessages :errors="errors" />
      </div>

      <div class="row no-gap">
        <v-btn class="duplicate-btn mr-1" @click="modalViewContractduplicate()">
          <i class="fas fa-clone mr-1"></i>
          Duplicar Contrato
        </v-btn>

        <v-btn
          class="print-btn mr-1"
          @click="directToPrintViewContract(contract_id)"
        >
          <i class="fas fa-print mr-1"></i>
          Imprimir Contrato
        </v-btn>

        <v-btn
          v-if="permission('edit', 'contract')"
          class="btn-add-modern mr-1"
          @click="directToUpdateContract(contract_id, resident_id)"
        >
          <i class="fas fa-file-alt sidebar-icon mr-2"></i>
          <span>Editar Contrato</span>
        </v-btn>
      </div>
    </b-modal>

    <DuplicateModal :contract_id="contract_id" :contract_name="contract.name" />
  </div>
</template>

<script>
import DuplicateModal from "./DuplicateModal";

import ErrorsMessages from "../Components/ErrorsMessages";

import api from "../../services/api";

import routes from "../../routes";

import permission from "../../lib/permission";

export default {
  name: "ViewModal",

  components: {
    ErrorsMessages,
    DuplicateModal,
  },

  props: {
    resident_id: {
      type: Number,
      default: null,
    },

    contract_id: {
      type: Number,
      default: null,
    },
  },

  data() {
    return {
      loading: false,

      replaced_text: "",

      contract: [],

      errors: [],
    };
  },

  watch: {
    async contract_id() {
      await this.getContract();
    },
  },

  methods: {
    permission,

    async getContract() {
      try {
        this.loading = true;

        const { contract_id } = this;

        let params = { contract_id };

        const response = await api.get("/contract", {
          params,
        });

        const { error, errors, contract, replaced_text } = response.data;

        if (!error) {
          this.errors = [];

          this.contract = contract;

          this.replaced_text = replaced_text;
        } else {
          this.errors = errors;
        }

        this.loading = false;
      } catch (error) {
        this.loading = false;

        console.log(error);
      }
    },

    directToUpdateContract: (contract_id, resident_id) =>
      routes.push({
        name: "contract-update",
        params: {
          contract_id: contract_id,
          resident_id: resident_id,
        },
      }),

    directToPrintViewContract: (contract_id) => {
      let route = routes.resolve({
        name: "contract-print",
        params: {
          contract_id,
        },
      });

      window.open(route.href, "_blank");
    },

    formatContract(text) {
      if (!text) {
        return "";
      }

      return text.replace(/\n/g, "<br>");
    },

    modalViewContractduplicate() {
      this.$bvModal.show("view-modal-contract-duplicate");
    },
  },
};
</script>

<style scoped>
.row.no-gap {
  display: flex;
  justify-content: flex-end;
  gap: 10;
}

.row.no-gap v-btn {
  margin: 0;
  flex: 0 0 auto;
}

.btn-add-modern {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%) !important;
  color: white !important;
  border: none !important;
  border-radius: 12px !important;
  padding: 12px 24px !important;
  font-weight: 600 !important;
  text-transform: uppercase !important;
  letter-spacing: 0.5px !important;
  box-shadow: 0 4px 15px rgba(16, 185, 129, 0.3) !important;
  transition: all 0.3s ease !important;
}

.btn-add-modern:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 20px rgba(16, 185, 129, 0.4) !important;
}

.print-btn {
  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%) !important;
  color: white !important;
  border: none !important;
  border-radius: 12px !important;
  padding: 12px 24px !important;
  font-weight: 600 !important;
  text-transform: uppercase !important;
  letter-spacing: 0.5px !important;
  box-shadow: 0 4px 15px rgba(59, 130, 246, 0.3) !important;
  transition: all 0.3s ease !important;
}

.print-btn:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 20px rgba(59, 130, 246, 0.4) !important;
}

.duplicate-btn {
  background: linear-gradient(135deg, #f59e42 0%, #ea580c 100%) !important;
  color: white !important;
  border: none !important;
  border-radius: 12px !important;
  padding: 12px 24px !important;
  font-weight: 600 !important;
  text-transform: uppercase !important;
  letter-spacing: 0.5px !important;
  box-shadow: 0 4px 15px rgba(245, 158, 66, 0.3) !important;
  transition: all 0.3s ease !important;
}

.duplicate-btn:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 20px rgba(245, 158, 66, 0.4) !important;
}
</style>